import React, { useEffect } from 'react';
import { Cards } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Icon from '@mdi/react';
import { mdiBoomGate, mdiCogBox, mdiFuseBlade, mdiHomeCity, mdiLockSmart, mdiMapMarkerPath, mdiOfficeBuildingCog } from '@mdi/js';

const pageSize = 20;

export const ConfigPage = () => {
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    useEffect(() => {
        //handleRefresh();
    }, []);
    const handleOption = (ref: string) => {
        window.location.href = ref
    }
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Configuración', href: '#transcription-job-list' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>

                    <Cards
                        ariaLabels={{
                            itemSelectionLabel: (e, i) => `select ${i.name}`,
                            selectionGroupLabel: "Item selection"
                        }}
                        selectionType="single"
                        onSelectionChange={({ detail }) => handleOption(detail.selectedItems[0].id)}
                        cardDefinition={{

                            header: item => item.name
                            ,
                            sections: [
                                {
                                    header: "",
                                    content: item => item.description
                                },
                            ]
                        }}
                        cardsPerRow={[
                            { cards: 1 },
                            { minWidth: 500, cards: 3 }
                        ]}
                        entireCardClickable
                        items={[
                            {
                                id: "#config/property",
                                name: (<span>
                                    <Icon path={mdiOfficeBuildingCog} size={1.5} /> Propiedad</span>),
                                description: "Configuración de parámetros de la propiedad seleccionada",
                            },
                            {
                                id: "#config/accesses",
                                name: (<span>
                                    <Icon path={mdiBoomGate} size={1.5} /> Accesos</span>),
                                description: "Configuración de accesos y restricciones asociadas",
                            },
                            {
                                id: "#config/units",
                                name: (<span>
                                    <Icon path={mdiHomeCity} size={1.5} /> Unidades</span>),
                                description: "Unidades, usuarios asociados y parámetros asociados con respecto a geolocalización y permisos",
                            },
                            {
                                id: "#config/sectors",
                                name: (<span>
                                    <Icon path={mdiMapMarkerPath} size={1.5} /> Sectores</span>),
                                description: "Unidad de agrupamiento para accesos y geolocalización de ordenamiento",
                            },
                            {
                                id: "#config/devices",
                                name: (<span>
                                    <Icon path={mdiLockSmart} size={1.5} /> Dispositivos</span>),
                                description: "Unidad de agrupamiento para accesos y geolocalización de ordenamiento",
                            },
                        ]}
                        //mdiFuseBlade
                        header={<Header><Icon path={mdiCogBox} size={2} /> Configuración</Header>}
                    />
                </>
            }
        />
    );
};
